var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsDateString, IsString, IsUUID } from 'class-validator';
/**
 * `GET /documentation/patient/:patientId/appointments/:appointmentId/handoffs`:
 * the Übergabe (ADR-0041), one per Behandlungsplan of the Termin that has one
 * to show. Empty when there is nothing to show.
 */
export class TreatmentHandoffResponseDto {
    treatmentPlanId;
    /** The plan as the Therapeut saved it, on one line. */
    text;
    /** The Termin whose documentation the line was read from. */
    sourceAppointmentId;
    /** `YYYY-MM-DD` of that Termin. */
    sourceAppointmentDate;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], TreatmentHandoffResponseDto.prototype, "treatmentPlanId", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], TreatmentHandoffResponseDto.prototype, "text", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], TreatmentHandoffResponseDto.prototype, "sourceAppointmentId", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], TreatmentHandoffResponseDto.prototype, "sourceAppointmentDate", void 0);
//# sourceMappingURL=treatment-handoff-response.dto.js.map